import { APIS } from '../../../../utils/api-factory';

const CHAT_BASE_URL = APIS.CHAT_API;

/**
 * 1. Fetch Overall/Unread List of Conversations (Assignee-Filtered)
 */
export const fetchConversations = async (empId = 'SuperUser', unreadOnly = false, page = 0, size = 15) => {
    const url = `${CHAT_BASE_URL}/applications-with-latest-message?page=${page}&size=${size}&unreadOnly=${unreadOnly}&empId=${encodeURIComponent(empId)}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch conversation list');
    return response.json();
};

/**
 * 2. Search Chat by Application ID or Mobile Number
 */
export const searchConversation = async (queryValue, searchType = 'applicationId') => {
    const paramKey = searchType === 'mobile' ? 'mobileNumber' : 'applicationId';
    const url = `${CHAT_BASE_URL}/search?${paramKey}=${encodeURIComponent(queryValue)}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Search failed');
    return response.json();
};

/**
 * 3. Load Conversation Message History
 */
export const loadMessageHistory = async (userId, adminId = 'ADMIN') => {
    const url = `${CHAT_BASE_URL}/conversation/${encodeURIComponent(userId)}/${encodeURIComponent(adminId)}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to load message history');
    return response.json();
};

/**
 * 4. Send Message (REST Endpoint)
 */
export const sendMessage = async (senderId = 'ADMIN', receiverId, comment) => {
    const url = `${CHAT_BASE_URL}/sendMessage`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            senderId,
            receiverId,
            comment,
            senderType: 'ADMIN'
        })
    });
    if (!response.ok) throw new Error('Failed to send message');
    return response.json();
};

/**
 * 5. Mark All Messages as Read
 */
export const markAllAsRead = async (userId, senderId) => {
    const url = `${CHAT_BASE_URL}/markAllMessagesAsRead?userId=${encodeURIComponent(userId)}&senderId=${encodeURIComponent(senderId)}`;
    const response = await fetch(url, {
        method: 'PUT'
    });
    if (!response.ok) throw new Error('Failed to mark messages as read');
    return response.text();
};

/**
 * 6. Toggle Application as Favorite (Employee-Scoped)
 */
export const toggleFavorite = async (applicationId, empId) => {
    const url = `${CHAT_BASE_URL}/toggleFavorite?applicationId=${encodeURIComponent(applicationId)}&empId=${encodeURIComponent(empId)}`;
    const response = await fetch(url, {
        method: 'POST'
    });
    if (!response.ok) throw new Error('Failed to toggle favorite');
    return response.text();
};

/**
 * 7. Get Favorites List (Employee-Scoped)
 */
export const fetchFavorites = async (empId, page = 0, size = 15) => {
    const url = `${CHAT_BASE_URL}/favorites?page=${page}&size=${size}&empId=${encodeURIComponent(empId)}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch favorites');
    return response.json();
};

/**
 * 8. Mark Single Message as Read
 */
export const markSingleAsRead = async (messageId) => {
    const url = `${CHAT_BASE_URL}/markMessageAsRead?messageId=${encodeURIComponent(messageId)}`;
    const response = await fetch(url, {
        method: 'PUT'
    });
    if (!response.ok) throw new Error('Failed to mark message as read');
    return response.text();
};

/**
 * 9. Get Unread Count for a Customer
 */
export const getUnreadCount = async (userId) => {
    const url = `${CHAT_BASE_URL}/getUnreadMessageCount?userId=${encodeURIComponent(userId)}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to get unread message count');
    return response.json();
};
